import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChange,
  OnDestroy,
} from '@angular/core';
import { ReportService } from '../../service/report.service';
import { FlowMeterService } from '../../service/flowmeter.service';
import { formatDate } from '@angular/common';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-flowmeterreport',
  templateUrl: './flowmeterreport.component.html',
})
export class FlowmeterreportComponent implements OnInit, OnChanges, OnDestroy {
  // Property declaration
  subscription: Subscription;
  tableHeight: number = 440;
  ReportData: any;
  @Input() FromDate;
  @Input() ToDate;
  @Input() MeterId: string;
  @Input() NodataFound: boolean;
  @Input() MeterMasterID: number;
  @Input() IsFromUserReport: string;
  @Input() ReportName: string;
  @Input() companyCode: string;
  @Input() callSerchclick: number;
  IsShow: boolean = false;
  noDataMsg: string = '';
  Type: string = '';
  @Input() StartTime;
  @Input() TimeInterval;
  @Input() EndTime;
  @Input() GraphType;

  errorMsg: string = '';
  @Input() IsGetReportData: boolean = false;
  ReportData1: any;
  totalflag: any;
  totaltagflag: boolean;

  constructor(
    private reportservice: ReportService,
    private flowmeterservice: FlowMeterService
  ) {}

  ngOnInit(): void {
    this.setType();
    const source = interval(300000);
    this.subscription = source.subscribe((val) => {
      if (this.IsGetReportData === true) {
        this.GetReportData();
      }
    });
  }
  // function to check all value of object
  checkAllEmpty(obj): boolean {
    for (let key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== ' ') {
        return false;
      }
    }
    return true;
  }
  // Get Report Data
  GetReportData() {
    let newObj: any;

    newObj = {
      ReportName: this.ReportName,
      IsFromUserReport: this.IsFromUserReport,
      MeterMasterID: this.MeterMasterID,
      MeterId: this.MeterId,
      GraphType: this.GraphType,
      FromDate:
        [formatDate(this.FromDate, 'yyyy-MM-dd', 'en')][0] +
        ' ' +
        this.StartTime,
      ToDate:
        [formatDate(this.ToDate, 'yyyy-MM-dd', 'en')][0] + ' ' + this.EndTime,
      companyCode: this.companyCode,
      TimeInterval: this.TimeInterval,
      isFrom: this.ReportName == 'Daily Report' ? '' : 'Consumption',
    };
    if (this.GraphType == 'Monthly' || this.GraphType == 'Yearly') {
      delete newObj.TimeInterval;
    }

    this.flowmeterservice.GetFlowMeterReportData(newObj).subscribe(
      (result) => {
        if (result.DeviceData.length > 0) {
          this.ReportData = result;
          if (this.ReportData && this.ReportData.TotalData) {
            this.totaltagflag = this.checkAllEmpty(
              this.ReportData.TotalData[0]
            );
          }
          this.totalflag = false;
          if (this.GraphType == 'Yearly' && this.ReportName == 'Daily Report') {
            const deviceData = result.DeviceData;
            for (const data of deviceData) {
              const date = new Date(data.RTC);
              const month = date.getMonth() + 1; // Adding 1 because getMonth() returns zero-based index
              const year = date.getFullYear();
              const formattedDate = `${
                month < 10 ? '0' + month : month
              }-${year}`;
              data.Str_RTC = formattedDate;
            }
          }
          this.IsShow = true;
          this.noDataMsg = '';
          this.ReportData.TotalData.forEach((obj) => {
            const values = Object.values(obj);
            if (values.every((value) => value == ' ')) {
              // Corrected from 'value == " "'
              this.totalflag = true;
            }
          });
        } else {
          this.IsShow = false;
          this.noDataMsg = 'No Data Found';
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // called when change any Input parameter
  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (this.NodataFound == true) {
      this.noDataMsg = 'No Data Found';
    }

    if (this.IsGetReportData == true) {
      this.GetReportData();
    } else {
      this.IsShow = false;
    }

    if (changes && changes.MeterId && changes.MeterId.firstChange === false) {
      this.setType();
    }
  }

  setType() {
    if (
      this.MeterId == 'SIPL1000000004000001' ||
      this.MeterId === 'SIPL1000000004000002'
    ) {
      this.Type = 'RMSPRAYAS';
    } else {
      this.Type = 'EMS';
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe(); // Unsubscribes all at once
  }
}
